module.exports = __webpack_public_path__ + "static/media/top_shape_8_mob.718f92f0.svg";